import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateAuthorityMutation as UpdateAuthorityMutationType,
  UpdateAuthorityMutationVariables,
} from "./__generated__/UpdateAuthorityMutation";

const UpdateAuthorityMutation = loader("./UpdateAuthorityMutation.gql");

type UpdateAuthorityMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateAuthorityMutationType) => void;
}) => ReactElement;

export const UpdateAuthorityMutationProvider: UpdateAuthorityMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateAuthorityMutationType, UpdateAuthorityMutationVariables>(
    UpdateAuthorityMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
